import useGetDataUser from "./useGetDataUser";

/**
 * Devuelve los permisos del usuario para un módulo específico, además del userId.
 * Usa useGetDataUser internamente, así que "info" es undefined en el primer render
 * (parpadeo de un frame) hasta que sessionStorage se lee y desencripta.
 *
 * @param {string} padre  - Nombre del grupo padre (ej. "Cotizaciones empresariales")
 * @param {string} modulo - Nombre del módulo (ej. "Listado de cotizaciones")
 * @returns {{ tienePermiso: (nombre: string) => boolean, userId: number|undefined, session: object|undefined }}
 */
const usePermisosModulo = (padre, modulo) => {
    const session = useGetDataUser();

    const permisos = session?.permissions ?? [];
    const grupo = permisos.find((g) => g.padre === padre);
    const mod = grupo?.modulos.find((m) => m.nombre === modulo);
    const permisosModulo = mod?.permisos ?? [];

    const tienePermiso = (nombre) => permisosModulo.includes(nombre);

    return {
        tienePermiso,
        userId: session?.user?.ID,
        session,
    };
};

export default usePermisosModulo;
